import { useEffect } from "react";

const SEO = ({ title, description, keywords, url }) => {
  useEffect(() => {
    document.title = title;

    const setMetaTag = (name, content, property = false) => {
      let element = property
        ? document.querySelector(`meta[property='${name}']`)
        : document.querySelector(`meta[name='${name}']`);

      if (!element) {
        element = document.createElement("meta");
        property
          ? element.setAttribute("property", name)
          : element.setAttribute("name", name);
        document.head.appendChild(element);
      }

      element.setAttribute("content", content);
    };

    setMetaTag("description", description);
    setMetaTag("keywords", keywords);

    // Canonical
let link = document.querySelector("link[rel='canonical']");
if (!link) {
  link = document.createElement("link");
  link.setAttribute("rel", "canonical");
  document.head.appendChild(link);
}
link.setAttribute("href", url);


    // Open Graph
    setMetaTag("og:title", title, true);
    setMetaTag("og:description", description, true);
    setMetaTag("og:url", url, true);
    setMetaTag("og:type", "website", true);

  }, [title, description, keywords, url]);

  return null;
};

export default SEO;
